import React, { useState, useEffect } from 'react';

import cx from 'classnames';
import styles from '../report.module.scss';

export function Pagination({ pagination, onClick, type }) {
  const { current, totalPages, totalRecordsCount } = pagination;

  const start = (current * 5) + 1;
  const end = Math.min(start + 4, totalRecordsCount);
  const show = current >= 0 && totalPages > 1;

  const handlePrevious = () => {
    var page = current - 1;
    if (page >= 0) {
      onClick(page);
    }
  }

  const handleNext = () => {
    var page = current + 1;
    if (page < totalPages) {
      onClick(page);
    }
  }

  if (!show) {
    return false;
  }

  return (
    <div className={cx(styles.paginationContainer)}>
      <div className={styles.pagination}>
        <div className={cx(styles.paginationArrow, { [styles.disable]: (current == 0) })} onClick={handlePrevious}>
          <img alt="leftArrowIcon" className={styles.arrowIcon} src='/images/reports/left_arrow.svg' />
        </div>

        <span><span className={styles.pageNumber}>{start} - {end}</span> of <span className={styles.pageNumber}>{totalRecordsCount}</span> {type ? type : ''}</span>

        <div className={cx(styles.paginationArrow, { [styles.disable]: current >= totalPages - 1 })} onClick={handleNext}>
          <img alt="rightArrowIcon" className={styles.arrowIcon} src='/images/reports/right_arrow.svg' />
        </div>
      </div>
    </div>
  );
}